import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { AuthPage, useAuthStore } from '@/stores/auth'
import Confirmation from '@/components/Confirmation.vue'
import { ref } from 'vue'
import type { ConfirmationType } from '@/misc/custom-types'


export default /*#__PURE__*/_defineComponent({
  __name: 'TwoFactorSetupInfo',
  setup(__props) {

const authStore = useAuthStore()

const { page } = storeToRefs(authStore)

const confirm = ref<ConfirmationType>()

const openDownloadPopup = async (platform: 'android' | 'ios') => {
  const url = platform === 'android'
    ? 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=nl-NL'
    : 'https://apps.apple.com/nl/app/google-authenticator/id388497605'

  await confirm.value?.open({
    message: `
      <div>
        <img src="/assets/images/google-authenticator-qr-code.png" class="google-auth-img" alt="Google Authenticator QR-code">
        <p>
          Scan de QR-code met je telefoon of klik <a href="${url}" target="_blank">hier</a>
        </p>
      </div>
    `,
    showSubmit: true,
    showCancel: false,
    showSwalType: false,
    submitText: 'Sluiten',
    popupStyle: {
      'width': '29em !important'
    }
  })
}

return { __sfc: true,authStore, page, confirm, openDownloadPopup, AuthPage, Confirmation }
}

})